const FlagJapanese = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='16' fill='none' viewBox='0 0 23 16'>
    <path fill='#fff' d='M22.824.186H.464v14.906h22.36V.186z'></path>
    <path fill='#AC001F' d='M15.836 7.64a4.191 4.191 0 11-8.383 0 4.191 4.191 0 018.383 0z'></path>
  </svg>
)

export { FlagJapanese }
